import { render, staticRenderFns } from "./ESituacaoAutorizacao.vue?vue&type=template&id=5cec272d"
import script from "./ESituacaoAutorizacao.vue?vue&type=script&lang=js"
export * from "./ESituacaoAutorizacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports